var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',{staticClass:"pa-2 text-center"},[_c('span',{class:{
				'd-inline': _vm.$vuetify.breakpoint.mdAndUp,
				'd-block caption': _vm.$vuetify.breakpoint.smAndDown,
			}},[_vm._v(" Some kind of plug for the university/a particular course  ")]),_c('a',{attrs:{"target":"_blank","href":"https://www.example.com"}},[_c('span',{class:{
					'd-inline': _vm.$vuetify.breakpoint.mdAndUp,
					'd-block caption': _vm.$vuetify.breakpoint.smAndDown,
				}},[_vm._v(" Take a look at our courses at the "),_c('span',[_vm._v("Place")]),_c('img',{staticClass:"ml-1",attrs:{"height":"15","src":require("@/assets/img/ethz_logo.svg"),"alt":"University of Reading logo"}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }